import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class AmApiKeyService {
  private readonly STORAGE_KEY = 'AM_API_KEY';
  private apiKey: string | null = null;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    // Restore persisted apiKey on browser refresh
    if (isPlatformBrowser(this.platformId)) {
      try {
        const saved = localStorage.getItem(this.STORAGE_KEY);
        if (saved) {
          this.apiKey = saved;
        }
      } catch {
        // ignore storage access errors
      }
    }
  }

  enable(key: string) {
    this.apiKey = (key || '').trim();
    if (isPlatformBrowser(this.platformId)) {
      try {
        if (this.apiKey) {
          localStorage.setItem(this.STORAGE_KEY, this.apiKey);
        } else {
          localStorage.removeItem(this.STORAGE_KEY);
        }
      } catch {
        // ignore storage access errors
      }
    }
  }

  disable() {
    this.apiKey = null;
    if (isPlatformBrowser(this.platformId)) {
      try {
        localStorage.removeItem(this.STORAGE_KEY);
      } catch {
        // ignore storage access errors
      }
    }
  }

  isEnabled(): boolean {
    return !!this.apiKey;
  }

  getKey(): string | null {
    return this.apiKey;
  }
}
